import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-banner-mypath',
    templateUrl: './banner-mypath.component.html',
    styleUrls: ['./banner-mypath.component.scss'],
    standalone: false
})
export class BannerMypathComponent implements OnInit {
  @Input() texto: string = '';
  @Input() modulo: string = '';

  imagenBanner: string = '';

  constructor() { }

  ngOnInit(): void {
    switch(this.modulo){
      case 'servicios-especializados-logistica':
          this.imagenBanner = 'assets/img/servicios-especializados/logistica/Mypath_3.webp';
          break;
      case 'servicios-especializados-promotoria':
          this.imagenBanner = 'assets/img/servicios-especializados/promotoria/MyPath4.webp';
          break;
      case 'servicios-especializados-administracion':
          this.imagenBanner = 'assets/img/servicios-especializados/administracion/MyPath5.webp';
          break;
      case 'servicios-especializados-ingenieria-construccion':
          this.imagenBanner = 'assets/img/servicios-especializados/ingenieria/MyPath6.webp';
          break;
      default:
        this.imagenBanner = 'assets/img/servicios-especializados/Mypath_Logo.png';
    }
  }

}
